import { useState, useEffect } from 'react'
import {
  getWarehouseAndTenant,
  Warehouse,
  Tenant,
} from 'repositories/ReceptionApi/getWarehouseAndTenant'

export const useWarehouseAndTenant = (warehouseId: string, tenantId: string) => {
  const [warehouse, setWarehouse] = useState<Warehouse | null>(null)
  const [tenant, setTenant] = useState<Tenant | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<Error | null>(null)

  useEffect(() => {
    if (!warehouseId || !tenantId) {
      setLoading(false)
      return
    }
    
    const fetchData = async () => {
      setLoading(true)
      try {
        const response = await getWarehouseAndTenant(warehouseId, tenantId)
        setWarehouse(response.data.warehouse)
        setTenant(response.data.tenant)
      } catch (err) {
        setError(err as Error)
      } finally {
        setLoading(false)
      }
    }
    fetchData()
  }, [warehouseId, tenantId])

  return { warehouse, tenant, loading, error }
}
